import { clone, cloneDeep, keys } from "lodash";
import { menu } from "app/menu/menu";
import { CoreMenu } from "@core/types";
import { ROLE } from "app/main/shared/enums/Roles.enum";

export const modulesByRole: MenuByRole = cloneDeep(menu).reduce(
  (prev, curr) => ({
    ...prev,
    [curr.module]: {
      roleAccess: curr.role,
      name: curr.title,
    },
  }),
  {}
);

export const modulesRoleAccess = (role: string): PermissionModules =>
  keys(modulesByRole).reduce(
    (prev, module) => ({
      ...prev,
      ...(modulesByRole[module].roleAccess.includes(role)
        ? {
            [module]: {
              name: modulesByRole[module].name,
              access: false,
            },
          }
        : {}),
    }),
    {}
  );

export const filterModulesRoleAccess = (role: string): PermissionModules =>
  keys(modulesByRole).reduce(
    (prev, module) => ({
      ...prev,
      ...(modulesByRole[module].roleAccess.includes(role)
        ? { [module]: { name: modulesByRole[module].name, access: false } }
        : {}),
    }),
    {}
  );

export const modulesWithAccessForRole = (role: string): PermissionModules =>
  keys(modulesByRole).reduce(
    (prev, module) => ({
      ...prev,
      ...(modulesByRole[module].roleAccess.includes(role)
        ? { [module]: { name: modulesByRole[module].name, access: true } }
        : {}),
    }),
    {}
  );

type AclModules = {
  [index: string]: {
    name: string;
    access: boolean;
  };
};
export const filterMenuModulesByRoleAndAcl = (role: ROLE, acl: AclModules) =>
  cloneDeep(menu)
    .filter(
      (item: CoreMenu) =>
        (item.role.includes(role) && acl[item.module]?.access) ?? true
    )
    .map(
      (
        item // * Filtrar por componente
      ) =>
        item.children
          ? {
              ...item,
              children: item.children.filter((item: CoreMenu) =>
                item.role.includes(role)
              ),
            }
          : item
    );

export const filterMenuModulesByRole = (role: ROLE) =>
  cloneDeep(menu)
    .filter((item: CoreMenu) => item.role.includes(role))
    .map(
      (
        item // * Filtrar por componente
      ) =>
        item.children
          ? {
              ...item,
              children: item.children.filter((item: CoreMenu) =>
                item.role.includes(role)
              ),
            }
          : item
    );

export const getModulesNameRoleAccess = (role: ROLE) =>
  filterMenuModulesByRole(role).map((item) => item.module);

export interface PermissionModules {
  [index: string]: ModuleItem;
}
export interface ModuleItem {
  name: string;
  access: boolean;
}

export interface MenuByRole {
  [index: string]: MenuByRoleItem;
}

export interface MenuByRoleItem {
  name: string;
  roleAccess: string[];
}
